import { render, staticRenderFns } from "./RegulatoryReportWrapper.vue?vue&type=template&id=499d11ba&scoped=true&"
import script from "./RegulatoryReportWrapper.vue?vue&type=script&lang=js&"
export * from "./RegulatoryReportWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499d11ba",
  null
  
)

export default component.exports